import { __extends } from "tslib";
/**
 * Defines an GC Friendly array where the backfield array do not shrink to prevent over allocations.
 */
var SmartArray = /** @class */ (function () {
    /**
     * Instantiates a Smart Array.
     * @param capacity defines the default capacity of the array.
     */
    function SmartArray(capacity) {
        /**
         * The active length of the array.
         */
        this.length = 0;
        this.data = new Array(capacity);
        this._id = SmartArray._GlobalId++;
    }
    /**
     * Pushes a value at the end of the active data.
     * @param value defines the object to push in the array.
     */
    SmartArray.prototype.push = function (value) {
        this.data[this.length++] = value;
        if (this.length > this.data.length) {
            this.data.length *= 2;
        }
    };
    /**
     * Iterates over the active data and apply the lambda to them.
     * @param func defines the action to apply on each value.
     */
    SmartArray.prototype.forEach = function (func) {
        for (var index = 0; index < this.length; index++) {
            func(this.data[index]);
        }
    };
    /**
     * Sorts the full sets of data.
     * @param compareFn defines the comparison function to apply.
     */
    SmartArray.prototype.sort = function (compareFn) {
        this.data.sort(compareFn);
    };
    /**
     * Resets the active data to an empty array.
     */
    SmartArray.prototype.reset = function () {
        this.length = 0;
    };
    /**
     * Releases all the data from the array as well as the array.
     */
    SmartArray.prototype.dispose = function () {
        this.reset();
        if (this.data) {
            this.data.length = 0;
            this.data = [];
        }
    };
    /**
     * Concats the active data with a given array.
     * @param array defines the data to concatenate with.
     */
    SmartArray.prototype.concat = function (array) {
        if (array.length === 0) {
            return;
        }
        if (this.length + array.length > this.data.length) {
            this.data.length = (this.length + array.length) * 2;
        }
        for (var index = 0; index < array.length; index++) {
            this.data[this.length++] = (array.data || array)[index];
        }
    };
    /**
     * Returns the position of a value in the active data.
     * @param value defines the value to find the index for
     * @returns the index if found in the active data otherwise -1
     */
    SmartArray.prototype.indexOf = function (value) {
        var position = this.data.indexOf(value);
        if (position >= this.length) {
            return -1;
        }
        return position;
    };
    /**
     * Returns whether an element is part of the active data.
     * @param value defines the value to look for
     * @returns true if found in the active data otherwise false
     */
    SmartArray.prototype.contains = function (value) {
        return this.indexOf(value) !== -1;
    };
    // Statics
    SmartArray._GlobalId = 0;
    return SmartArray;
}());
export { SmartArray };
/**
 * Defines an GC Friendly array where the backfield array do not shrink to prevent over allocations.
 * The data in this array can only be present once
 */
var SmartArrayNoDuplicate = /** @class */ (function (_super) {
    __extends(SmartArrayNoDuplicate, _super);
    function SmartArrayNoDuplicate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._duplicateId = 0;
        return _this;
    }
    /**
     * Pushes a value at the end of the active data.
     * THIS DOES NOT PREVENT DUPPLICATE DATA
     * @param value defines the object to push in the array.
     */
    SmartArrayNoDuplicate.prototype.push = function (value) {
        _super.prototype.push.call(this, value);
        if (!value.__smartArrayFlags) {
            value.__smartArrayFlags = {};
        }
        value.__smartArrayFlags[this._id] = this._duplicateId;
    };
    /**
     * Pushes a value at the end of the active data.
     * If the data is already present, it won t be added again
     * @param value defines the object to push in the array.
     * @returns true if added false if it was already present
     */
    SmartArrayNoDuplicate.prototype.pushNoDuplicate = function (value) {
        if (value.__smartArrayFlags && value.__smartArrayFlags[this._id] === this._duplicateId) {
            return false;
        }
        this.push(value);
        return true;
    };
    /**
     * Resets the active data to an empty array.
     */
    SmartArrayNoDuplicate.prototype.reset = function () {
        _super.prototype.reset.call(this);
        this._duplicateId++;
    };
    /**
     * Concats the active data with a given array.
     * This ensures no dupplicate will be present in the result.
     * @param array defines the data to concatenate with.
     */
    SmartArrayNoDuplicate.prototype.concatWithNoDuplicate = function (array) {
        if (array.length === 0) {
            return;
        }
        if (this.length + array.length > this.data.length) {
            this.data.length = (this.length + array.length) * 2;
        }
        for (var index = 0; index < array.length; index++) {
            var item = (array.data || array)[index];
            this.pushNoDuplicate(item);
        }
    };
    return SmartArrayNoDuplicate;
}(SmartArray));
export { SmartArrayNoDuplicate };
//# sourceMappingURL=smartArray.js.map